module.exports = __webpack_public_path__ + "static/media/growTowers.8ac7b59f.jpg";